import { Box, Grid, Paper } from "@material-ui/core";
import React, { FC } from "react";
import { useSelector } from "react-redux";
import AudioPlayerComponent from "./AudioPlayer";
import SpeechExample from "./SpeechExample";
import { SpeechExampleProps } from "./SpeechExample";
import { StateInterface } from "./state/reducer/store";

interface VoiceDemoProps {
  data: SpeechExampleProps[];
}
const VoiceDemo: FC<VoiceDemoProps> = ({ data }) => {
  const config = useSelector((state: StateInterface) => state.config)
  return (
    <Grid
      container
      style={{
        margin: 0,
        width: "100%",
      }}
      spacing={5}
    >
      {data.map((example) => (

        <Grid item md={3} key={example.author}>
          <Paper elevation={4}>

            <Box style={{ padding: 32 }}>
              <SpeechExample
                title={example.title}
                text={example.text}
                author={example.author}
              />
              <Box
                style={{
                  fontSize: 16,
                  letterSpacing: 1.5,
                  textDecoration: "underline",
                  marginTop: 16,
                  marginBottom: 16,
                  color: "gray",
                }}
              >
                <p style={{ marginLeft: 16 }}>{config.textByLanguage.free}</p>
              </Box>
              <AudioPlayerComponent src={example.freeAudio || ""} />

              <Box
                style={{
                  fontSize: 16,
                  marginTop: 16,
                  color: "#1976d2",
                  fontWeight: "bold",
                  letterSpacing: 1.2,
                  width: 200,
                  
                }}
              >
                <p style={{ marginLeft: 16 }}>{config.textByLanguage["audioPlayer.neuralVoice"]}</p>
              </Box>
              <Box>
                <AudioPlayerComponent src={example.premiumAudio || ""} premium />
              </Box>
            </Box>
          </Paper>
        </Grid>

      ))}
    </Grid>

  );
};

export default VoiceDemo;
